import { defineMessages } from "react-intl";
export default defineMessages({
    title: {
        id: "forecastMaps.title",
        defaultMessage: "Forecast maps",
    },
    metaDescription: {
        id: "forecastMaps.metaDescription",
        defaultMessage: "Animated forecast maps rendered from weather model runs.",
    },
    // --- Top-nav dropdown / stub views ---
    byZone: {
        id: "forecastMaps.byZone",
        defaultMessage: "By zone",
    },
    byModel: {
        id: "forecastMaps.byModel",
        defaultMessage: "By model",
    },
    comingSoon: {
        id: "forecastMaps.comingSoon",
        defaultMessage: "This view is coming soon.",
    },
    browseMaps: {
        id: "forecastMaps.browseMaps",
        defaultMessage: "Browse maps",
    },
    // --- Zone browse (by zone) region + country/area labels ---
    regionNorthAmerica: {
        id: "forecastMaps.regionNorthAmerica",
        defaultMessage: "North America",
    },
    regionEurope: {
        id: "forecastMaps.regionEurope",
        defaultMessage: "Europe",
    },
    countryFrance: {
        id: "forecastMaps.countryFrance",
        defaultMessage: "France",
    },
    countryGermany: {
        id: "forecastMaps.countryGermany",
        defaultMessage: "Germany",
    },
    countrySwitzerland: {
        id: "forecastMaps.countrySwitzerland",
        defaultMessage: "Switzerland",
    },
    countryItaly: {
        id: "forecastMaps.countryItaly",
        defaultMessage: "Italy",
    },
    countrySpain: {
        id: "forecastMaps.countrySpain",
        defaultMessage: "Spain",
    },
    countryScandinavia: {
        id: "forecastMaps.countryScandinavia",
        defaultMessage: "Scandinavia",
    },
    countryUnitedStates: {
        id: "forecastMaps.countryUnitedStates",
        defaultMessage: "United States",
    },
    countryCanada: {
        id: "forecastMaps.countryCanada",
        defaultMessage: "Canada",
    },
    forecastModel: {
        id: "forecastMaps.forecastModel",
        defaultMessage: "Forecast model",
    },
    map: {
        id: "forecastMaps.map",
        defaultMessage: "Map",
    },
    variable: {
        id: "forecastMaps.variable",
        defaultMessage: "Variable",
    },
    run: {
        id: "forecastMaps.run",
        defaultMessage: "Run: {run}",
    },
    validTime: {
        id: "forecastMaps.validTime",
        defaultMessage: "Valid at {time}",
    },
    hourOffset: {
        id: "forecastMaps.hourOffset",
        defaultMessage: "+{hour} h",
    },
    localTimeHint: {
        id: "forecastMaps.localTimeHint",
        defaultMessage: "Shown in your local time",
    },
    utcTime: {
        id: "forecastMaps.utcTime",
        defaultMessage: "UTC: {time}",
    },
    noMapsAvailable: {
        id: "forecastMaps.noMapsAvailable",
        defaultMessage: "No forecast maps are available yet.",
    },
    noCompletedRun: {
        id: "forecastMaps.noCompletedRun",
        defaultMessage: "This map has not been rendered yet. Please check back soon.",
    },
    retry: {
        id: "forecastMaps.retry",
        defaultMessage: "Retry",
    },
    play: {
        id: "forecastMaps.play",
        defaultMessage: "Play",
    },
    pause: {
        id: "forecastMaps.pause",
        defaultMessage: "Pause",
    },
    exportMp4: {
        id: "forecastMaps.exportMp4",
        defaultMessage: "Export MP4",
    },
    exportBuilding: {
        id: "forecastMaps.exportBuilding",
        defaultMessage: "Preparing video…",
    },
    downloadMp4: {
        id: "forecastMaps.downloadMp4",
        defaultMessage: "Download MP4",
    },
    exportNotReady: {
        id: "forecastMaps.exportNotReady",
        defaultMessage: "The video is not ready yet. Please try again later.",
    },
    exportError: {
        id: "forecastMaps.exportError",
        defaultMessage: "The video export failed. Please try again.",
    },
    // --- Interactive map view ---
    flipbookView: {
        id: "forecastMaps.flipbookView",
        defaultMessage: "Animation",
    },
    mapView: {
        id: "forecastMaps.mapView",
        defaultMessage: "Interactive map",
    },
    pointValueLoading: {
        id: "forecastMaps.pointValueLoading",
        defaultMessage: "Loading forecast…",
    },
    pointValueError: {
        id: "forecastMaps.pointValueError",
        defaultMessage: "Could not load the forecast for this point.",
    },
    pointValueUnavailable: {
        id: "forecastMaps.pointValueUnavailable",
        defaultMessage: "No data for this time.",
    },
    overlayLegend: {
        id: "forecastMaps.overlayLegend",
        defaultMessage: "Legend",
    },
    // --- Composer / map builder ---
    builderTitle: {
        id: "forecastMaps.builderTitle",
        defaultMessage: "Map builder",
    },
    builderMetaDescription: {
        id: "forecastMaps.builderMetaDescription",
        defaultMessage: "Compose custom forecast maps from weather model layers.",
    },
    backToMaps: {
        id: "forecastMaps.backToMaps",
        defaultMessage: "Back to maps",
    },
    newMap: {
        id: "forecastMaps.newMap",
        defaultMessage: "New map",
    },
    forkAndEdit: {
        id: "forecastMaps.forkAndEdit",
        defaultMessage: "Fork & edit",
    },
    editMap: {
        id: "forecastMaps.editMap",
        defaultMessage: "Edit map",
    },
    deleteMap: {
        id: "forecastMaps.deleteMap",
        defaultMessage: "Delete map",
    },
    myMaps: {
        id: "forecastMaps.myMaps",
        defaultMessage: "My maps",
    },
    presets: {
        id: "forecastMaps.presets",
        defaultMessage: "Presets",
    },
    deleteMapTitle: {
        id: "forecastMaps.deleteMapTitle",
        defaultMessage: "Delete this map?",
    },
    deleteMapBody: {
        id: "forecastMaps.deleteMapBody",
        defaultMessage: "“{name}” and its rendered runs will be permanently deleted.",
    },
    layers: {
        id: "forecastMaps.layers",
        defaultMessage: "Layers",
    },
    windAnimation: {
        id: "forecastMaps.windAnimation",
        defaultMessage: "Wind animation",
    },
    colorScale: {
        id: "forecastMaps.colorScale",
        defaultMessage: "Color scale",
    },
    addLayer: {
        id: "forecastMaps.addLayer",
        defaultMessage: "Add layer",
    },
    moveLayerUp: {
        id: "forecastMaps.moveLayerUp",
        defaultMessage: "Move up",
    },
    moveLayerDown: {
        id: "forecastMaps.moveLayerDown",
        defaultMessage: "Move down",
    },
    removeLayer: {
        id: "forecastMaps.removeLayer",
        defaultMessage: "Remove layer",
    },
    removeColor: {
        id: "forecastMaps.removeColor",
        defaultMessage: "Remove color",
    },
    noLayers: {
        id: "forecastMaps.noLayers",
        defaultMessage: "No layers yet. Add a layer to get started.",
    },
    maxLayersReached: {
        id: "forecastMaps.maxLayersReached",
        defaultMessage: "This map has reached the maximum of {max} layers.",
    },
    layerTypeFilledContour: {
        id: "forecastMaps.layerTypeFilledContour",
        defaultMessage: "Filled contours",
    },
    layerTypeContour: {
        id: "forecastMaps.layerTypeContour",
        defaultMessage: "Contour lines",
    },
    layerTypeRaster: {
        id: "forecastMaps.layerTypeRaster",
        defaultMessage: "Raster",
    },
    layerTypeBarbs: {
        id: "forecastMaps.layerTypeBarbs",
        defaultMessage: "Wind barbs",
    },
    layerTypeVectorField: {
        id: "forecastMaps.layerTypeVectorField",
        defaultMessage: "Vector field",
    },
    layerTypeMagnitude: {
        id: "forecastMaps.layerTypeMagnitude",
        defaultMessage: "Magnitude",
    },
    displayName: {
        id: "forecastMaps.displayName",
        defaultMessage: "Display name",
    },
    metric: {
        id: "forecastMaps.metric",
        defaultMessage: "Metric",
    },
    uMetric: {
        id: "forecastMaps.uMetric",
        defaultMessage: "U component",
    },
    vMetric: {
        id: "forecastMaps.vMetric",
        defaultMessage: "V component",
    },
    metricRequired: {
        id: "forecastMaps.metricRequired",
        defaultMessage: "Select a metric",
    },
    metricUnavailable: {
        id: "forecastMaps.metricUnavailable",
        defaultMessage: "Not available for this model",
    },
    uvMetricsDiffer: {
        id: "forecastMaps.uvMetricsDiffer",
        defaultMessage: "U and V metrics must differ",
    },
    colormap: {
        id: "forecastMaps.colormap",
        defaultMessage: "Colormap",
    },
    colormapGroupDomain: {
        id: "forecastMaps.colormapGroupDomain",
        defaultMessage: "Weather presets",
    },
    colormapGroupMatplotlib: {
        id: "forecastMaps.colormapGroupMatplotlib",
        defaultMessage: "Scientific presets",
    },
    colormapCustom: {
        id: "forecastMaps.colormapCustom",
        defaultMessage: "Custom colors",
    },
    addColor: {
        id: "forecastMaps.addColor",
        defaultMessage: "Add color",
    },
    invalidHexColor: {
        id: "forecastMaps.invalidHexColor",
        defaultMessage: "Invalid color — use #RRGGBB",
    },
    customColormapMinColors: {
        id: "forecastMaps.customColormapMinColors",
        defaultMessage: "A custom colormap needs at least two colors",
    },
    minValue: {
        id: "forecastMaps.minValue",
        defaultMessage: "Min value",
    },
    maxValue: {
        id: "forecastMaps.maxValue",
        defaultMessage: "Max value",
    },
    minMaxRequired: {
        id: "forecastMaps.minMaxRequired",
        defaultMessage: "Min and max values are required for this layer type",
    },
    minBelowMax: {
        id: "forecastMaps.minBelowMax",
        defaultMessage: "Min must be less than max",
    },
    opacity: {
        id: "forecastMaps.opacity",
        defaultMessage: "Opacity",
    },
    unitConversion: {
        id: "forecastMaps.unitConversion",
        defaultMessage: "Unit conversion",
    },
    unitNone: {
        id: "forecastMaps.unitNone",
        defaultMessage: "None",
    },
    nanPolicy: {
        id: "forecastMaps.nanPolicy",
        defaultMessage: "Missing data",
    },
    nanSkip: {
        id: "forecastMaps.nanSkip",
        defaultMessage: "Skip",
    },
    nanMask: {
        id: "forecastMaps.nanMask",
        defaultMessage: "Mask",
    },
    nanClipToMin: {
        id: "forecastMaps.nanClipToMin",
        defaultMessage: "Clip to min",
    },
    contourLevels: {
        id: "forecastMaps.contourLevels",
        defaultMessage: "Contour levels",
    },
    levelsModeLinspace: {
        id: "forecastMaps.levelsModeLinspace",
        defaultMessage: "Evenly spaced (count)",
    },
    levelsModeArange: {
        id: "forecastMaps.levelsModeArange",
        defaultMessage: "Fixed step",
    },
    levelsModeExplicit: {
        id: "forecastMaps.levelsModeExplicit",
        defaultMessage: "Explicit values",
    },
    levelsCount: {
        id: "forecastMaps.levelsCount",
        defaultMessage: "Count",
    },
    levelsStep: {
        id: "forecastMaps.levelsStep",
        defaultMessage: "Step",
    },
    levelsValues: {
        id: "forecastMaps.levelsValues",
        defaultMessage: "Values",
    },
    levelsValuesHint: {
        id: "forecastMaps.levelsValuesHint",
        defaultMessage: "Comma-separated, ascending",
    },
    levelsInvalid: {
        id: "forecastMaps.levelsInvalid",
        defaultMessage: "Invalid contour levels",
    },
    downscaling: {
        id: "forecastMaps.downscaling",
        defaultMessage: "Barb thinning factor",
    },
    mapSettings: {
        id: "forecastMaps.mapSettings",
        defaultMessage: "Map settings",
    },
    modelNoRun: {
        id: "forecastMaps.modelNoRun",
        defaultMessage: "No completed run yet",
    },
    customExtent: {
        id: "forecastMaps.customExtent",
        defaultMessage: "Custom extent",
    },
    useModelDomain: {
        id: "forecastMaps.useModelDomain",
        defaultMessage: "Off: the full model domain is used",
    },
    north: {
        id: "forecastMaps.north",
        defaultMessage: "North",
    },
    south: {
        id: "forecastMaps.south",
        defaultMessage: "South",
    },
    east: {
        id: "forecastMaps.east",
        defaultMessage: "East",
    },
    west: {
        id: "forecastMaps.west",
        defaultMessage: "West",
    },
    extentInvalid: {
        id: "forecastMaps.extentInvalid",
        defaultMessage: "West must be less than east and south less than north",
    },
    selectExtentOnMap: {
        id: "forecastMaps.selectExtentOnMap",
        defaultMessage: "Select area on map",
    },
    drawArea: {
        id: "forecastMaps.drawArea",
        defaultMessage: "Draw area",
    },
    useCurrentView: {
        id: "forecastMaps.useCurrentView",
        defaultMessage: "Use current view",
    },
    extentDrawHint: {
        id: "forecastMaps.extentDrawHint",
        defaultMessage: "Drag on the map to draw the area",
    },
    extentPanZoomHint: {
        id: "forecastMaps.extentPanZoomHint",
        defaultMessage: "Pan and zoom until the area fills the frame",
    },
    projection: {
        id: "forecastMaps.projection",
        defaultMessage: "Projection",
    },
    projectionPlateCarree: {
        id: "forecastMaps.projectionPlateCarree",
        defaultMessage: "Plate carrée",
    },
    projectionMercator: {
        id: "forecastMaps.projectionMercator",
        defaultMessage: "Mercator",
    },
    projectionLambertConformal: {
        id: "forecastMaps.projectionLambertConformal",
        defaultMessage: "Lambert conformal",
    },
    projectionStereographic: {
        id: "forecastMaps.projectionStereographic",
        defaultMessage: "Stereographic",
    },
    height: {
        id: "forecastMaps.height",
        defaultMessage: "Height (inches)",
    },
    dpi: {
        id: "forecastMaps.dpi",
        defaultMessage: "DPI",
    },
    valueBetween: {
        id: "forecastMaps.valueBetween",
        defaultMessage: "Must be between {min} and {max}",
    },
    memoryBudgetUsage: {
        id: "forecastMaps.memoryBudgetUsage",
        defaultMessage: "Render budget: {percent}%",
    },
    memoryBudgetExceeded: {
        id: "forecastMaps.memoryBudgetExceeded",
        defaultMessage: "The resolution exceeds the render budget — reduce DPI or height",
    },
    preview: {
        id: "forecastMaps.preview",
        defaultMessage: "Preview",
    },
    autoPreview: {
        id: "forecastMaps.autoPreview",
        defaultMessage: "Auto",
    },
    previewHour: {
        id: "forecastMaps.previewHour",
        defaultMessage: "Forecast hour",
    },
    previewRendering: {
        id: "forecastMaps.previewRendering",
        defaultMessage: "Rendering preview…",
    },
    previewFailed: {
        id: "forecastMaps.previewFailed",
        defaultMessage: "The preview failed",
    },
    previewEmptyHint: {
        id: "forecastMaps.previewEmptyHint",
        defaultMessage: "Configure at least one valid layer to render a preview.",
    },
    mapName: {
        id: "forecastMaps.mapName",
        defaultMessage: "Map name",
    },
    mapNameRequired: {
        id: "forecastMaps.mapNameRequired",
        defaultMessage: "Enter a name",
    },
    mapDescription: {
        id: "forecastMaps.mapDescription",
        defaultMessage: "Description",
    },
    save: {
        id: "forecastMaps.save",
        defaultMessage: "Save",
    },
    build: {
        id: "forecastMaps.build",
        defaultMessage: "Build",
    },
    buildStarting: {
        id: "forecastMaps.buildStarting",
        defaultMessage: "Starting build…",
    },
    buildProgress: {
        id: "forecastMaps.buildProgress",
        defaultMessage: "Rendering… {completed}/{total} steps",
    },
    buildCompleted: {
        id: "forecastMaps.buildCompleted",
        defaultMessage: "Build completed",
    },
    buildFailed: {
        id: "forecastMaps.buildFailed",
        defaultMessage: "The build failed. Please try again.",
    },
    buildNotPossible: {
        id: "forecastMaps.buildNotPossible",
        defaultMessage: "This map cannot be built yet — no forecast data is available.",
    },
    viewMap: {
        id: "forecastMaps.viewMap",
        defaultMessage: "View map",
    },
    unsavedChangesTitle: {
        id: "forecastMaps.unsavedChangesTitle",
        defaultMessage: "Unsaved changes",
    },
    unsavedChangesBody: {
        id: "forecastMaps.unsavedChangesBody",
        defaultMessage: "You have unsaved changes. Leave and discard them?",
    },
    leave: {
        id: "forecastMaps.leave",
        defaultMessage: "Leave",
    },
});
